import React, { useState, useEffect, useContext } from "react";
import { useDispatch } from "react-redux";
import { showLoading, hideLoading } from "../../redux/slices/loadingSlice";
import { useNavigate } from "react-router-dom";
import { SafeAreaContext } from "../../App";
import ProfileService from "../../services/Profile";
import ListButton from "./components/ListButton";
import StatCard from "./components/StatCard";
import PackageSheet from "./modals/PackageSheet";
import FaCandle from "./icons/FaCandle";
import FaReport from "./icons/FaReport";
import FaSupport from "./icons/FaSupport";
import { IoNotificationsSharp } from "react-icons/io5";
import { IoMdAdd } from "react-icons/io";
import {
    FaBell,
    FaCircleInfo,
    FaCrown,
    FaGear,
    FaGift,
    FaPercent,
} from "react-icons/fa6";
import { FaPen, FaWallet } from "react-icons/fa";
import { GoArrowDown } from "react-icons/go";
import { GiInjustice } from "react-icons/gi";
import { LuRefreshCw } from "react-icons/lu";
import { MdPhone } from "react-icons/md";
import defaultUser from "../../assets/images/anonymous.jpg.webp";
import {
    FiUser,
    FiHome,
    FiBarChart2,
    FiFileText,
    FiPlus,
    FiSlash, FiChevronRight,
} from "react-icons/fi";
import RenewSubscription from "./modals/RenewSubscription";
import Settings from "./pages/settings/settings";
import { showToast } from "../../redux/slices/toastSlice";
import { BiLogOut } from "react-icons/bi";

// function formatNumber(input) {
//     const digits = input.replace(/\D/g, "").slice(0, 11);
//
//     let formatted = "";
//     if (digits.length <= 4) {
//         formatted = digits;
//     } else if (digits.length <= 5) {
//         formatted = digits.slice(0, 4) + " " + digits.slice(4);
//     } else {
//         formatted =
//             digits.slice(0, 4) + " " + digits.slice(4, 7) + " " + digits.slice(7);
//     }
//     return formatted;
// }

const Profile = () => {
    const [openPackages, setOpenPackages] = useState(false);
    const [openInvite, setOpenInvite] = useState(false);
    const [openSettings, setOpenSettings] = useState(false);
    const [isRenewOpen, setIsRenewOpen] = useState(false);
    const [openWallet, setOpenWallet] = useState(false);
    const dispatch = useDispatch();

    //safArea for Pwa////////
    const { setSafeAreaColor } = useContext(SafeAreaContext);

    useEffect(() => {
        setSafeAreaColor({ background: "#6366f1" });
    }, []);
    const [profileInfo, setProfileInfo] = useState({});
    // const remainingDays = calculateRemainingDays(profileInfo?.expiration);
    const [remainingDays, setRemainingDays] = useState(0);

    async function getProfile() {
        try {
            const res = await ProfileService.getProfile();

            if (res?.status === 200) {
                const user = res.data?.data?.finduser;

                setProfileInfo(user);

                const days = calculateRemainingDays(user?.expiration);
                setRemainingDays(days);

                if (!user?.fullName) {
                    navigate("/completeProfile");

                    dispatch(
                        showToast({
                            message: "Please complete your profile first",
                            type: "error",
                        })
                    );
                }
            }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        getProfile();
    }, []);

    // function handleImageEditClick() {
    //     imageRef.current.click();
    // }

    // async function changeImageProfile(e) {
    //     const file = e.target.files[0];
    //
    //     if (file) {
    //         setImage(URL.createObjectURL(file));
    //         await sendImg(file);
    //     }
    // }

    // async function editProfile(id) {
    //     try {
    //         const body = {
    //             imageId: id,
    //         };
    //         const res = await ProfileService.editProfile(body);
    //             getProfile();
    //     } catch (err) {
    //         console.log("Edit profile error:", err);
    //     }
    // }

    // const token = useSelector((state) => state.login.token);

    // async function sendImg(file) {
    //     const formData = new FormData();
    //     formData.append("file", file);
    //     dispatch(showLoading());
    //     try {
    //         const response = await fetch(
    //             "https://api.7-trade.ir/api/file/v1/updload",
    //             {
    //                 method: "POST",
    //                 body: formData,
    //                 headers: {
    //                     Authorization: `Bearer ${token || null}`,
    //                 },
    //             },
    //         );
    //
    //         const data = await response.json();
    //
    //         await editProfile(data.message._id);
    //     } catch (err) {
    //         console.error("Upload error:", err);
    //     } finally {
    //         dispatch(hideLoading());
    //     }
    // }

    // useEffect(() => {
    //     async function getProfile() {
    //         try {
    //             const res = await ProfileService.getProfile();
    //             if (res?.status === 200) {
    //                 const user = res.data?.data?.finduser;
    //                 setProfileInfo(user);

    //                 const days = calculateRemainingDays(user?.expiration);
    //                 setRemainingDays(days); // <-- here
    //             }
    //         } catch (err) {
    //             console.error(err);
    //         }
    //     }

    //     getProfile();
    // }, []);

    ///////////////////////////////////
    // useEffect(() => {
    //   if (openSubscription) {
    //     document.body.style.overflow = "hidden";
    //     document.documentElement.style.overflow = "hidden";
    //   }
    // }, [openSubscription]);
    /////////////////////////////////

    useEffect(() => {
        if (openInvite || openWallet) {
            document.body.style.overflow = "hidden";
            document.documentElement.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
            document.documentElement.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
            document.documentElement.style.overflow = "auto";
        };
    }, [openInvite, openWallet]);

    function calculateRemainingDays(expirationDate) {
        if (!expirationDate) return 0;

        const now = new Date();
        const exp = new Date(expirationDate);

        const diffTime = exp - now;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return diffDays > 0 ? diffDays : 0;
    }

    const balance = profileInfo?.wallet?.balance ?? 0;
    const expiration = profileInfo?.expiration;
    const daysLeft = remainingDays ?? 0;
    const progress = Math.max(0, Math.min((daysLeft / 30) * 100, 100));


    const navigate = useNavigate();

    async function logout() {
        dispatch(showLoading());
        try {
            // await ProfileService.logOut();
            sessionStorage.clear();
            localStorage.clear()
            window.location.reload();

        } catch (error) {
            console.error('Failed to logout: ', error);
        } finally {
            dispatch(hideLoading());
        }
    }
    return (
        <div dir="ltr" className="min-h-screen bg-gray-50 w-full font-vazir pb-10">
            {openSettings && <Settings setOpenSettings={setOpenSettings} />}
            {/* Header */}
            <header className="bg-gradient-to-br from-white to-gray-50 pt-6 pb-8 px-5 relative">
                <div className="absolute top-4 left-4 flex items-center gap-3">
                    <button
                        onClick={() => setOpenSettings(true)}
                        className="w-11 h-11 bg-white/80 backdrop-blur-sm rounded-2xl flex items-center justify-center hover:bg-white transition-all shadow-sm border border-gray-100"
                    >
                        <FaGear className="text-gray-600" />
                    </button>
                </div>

                <div className="absolute top-4 right-4 flex items-center gap-3">
                    <button
                        className="w-11 h-11 bg-white/80 backdrop-blur-sm rounded-2xl flex items-center justify-center hover:bg-white transition-all shadow-sm border border-gray-100 relative">
                        <FaBell className="text-gray-600" />
                        {/* <span className="absolute -top-1 -right-1 bg-red-500 w-5 h-5 rounded-full text-xs flex items-center justify-center text-white font-bold border-2 border-white shadow-sm">۳</span> */}
                    </button>
                </div>

                <div className="flex flex-col items-center mt-10">
                    <div className="relative mb-6">
                        <div className="w-32 h-32 rounded-3xl bg-white p-2 shadow-xl border border-gray-100">
                            <img
                                src={
                                    profileInfo?.imageId?.path
                                        ? `https://api.7-trade.ir/${profileInfo?.imageId?.path}`
                                        : defaultUser
                                }
                                className="w-full h-full rounded-2xl object-cover"
                                alt={''}
                            />
                        </div>
                        <div
                            onClick={() => navigate("/completeProfile")}
                            className="absolute -bottom-2 -right-2 w-12 h-12 bg-white/90 backdrop-blur-md rounded-2xl flex items-center justify-center shadow-lg border border-gray-200 cursor-pointer hover:bg-white transition-all"
                        >
                            {/* <input
                ref={imageRef}
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={changeImageProfile}
              /> */}
                            <FaPen className="text-gray-700 text-sm" />
                        </div>
                    </div>

                    <div className="text-center">
                        <h2 className="text-2xl font-bold text-gray-900 mb-1">
                            {profileInfo?.fullName || "- -"}
                        </h2>
                        {/* <span className="text-base text-gray-500 mb-3 block">{profileInfo?.userName || "-"}</span> */}
                        <div
                            className="inline-flex items-center bg-white/60 backdrop-blur-sm px-4 py-2 rounded-full border border-gray-100">
                            <span className="text-sm font-medium text-gray-700">
                                {profileInfo?.mobile || "-"}
                            </span>
                            <MdPhone className="text-primary text-sm ml-2" />
                        </div>
                    </div>
                </div>
            </header>

            {/* Quick Stats */}
            <main className="px-4 mt-4 relative  mb-6">
                <div className="grid grid-cols-2 gap-3">
                    <StatCard
                        action={() => navigate("/wallet")}
                        icon={<FaWallet size={16} className="text-green-600" />}
                        bgIconColor="bg-green-100"
                        value={balance.toLocaleString()}
                        title="USDT"
                        footer="Wallet Balance"
                        button={<IoMdAdd size={14} className="text-green-600" />}
                    />

                    <StatCard
                        action={() => navigate("/renew")}
                        icon={<FaCrown size={16} className="text-primary" />}
                        bgIconColor="bg-primary/10"
                        value={daysLeft}
                        title="Days"
                        footer={
                            expiration
                                ? `Expiration: ${new Date(expiration).toLocaleDateString("en-CA")}`
                                : ""
                        }
                        progress={progress}
                        button={<LuRefreshCw size={14} className="text-primary" />}
                    />

                </div>

                <div className="bg-white rounded-2xl p-4 shadow-lg border border-gray-100 mt-3">
                    <button
                        onClick={() => navigate("/invite")}
                        className="w-full flex items-center justify-between"
                    >
                        <div className="flex items-center gap-6">
                            <div className="min-w-10 min-h-10 bg-yellow-50 rounded-xl flex items-center justify-center">
                                <FaGift size={16} className="text-yellow-600" />
                            </div>

                            <div className="text-left mr-3">
                                <h3 className="font-semibold text-gray-900">
                                    Get Referral Code
                                </h3>
                                <p className="text-sm text-gray-500">
                                    Invite your friends and both of you will receive a 50,000 USDT bonus.
                                </p>
                            </div>
                        </div>

                        <FiChevronRight size={20} className="text-gray-400" />
                    </button>
                </div>

                <div className="bg-white rounded-2xl p-4 shadow-lg border border-gray-100 mt-3">
                    <div className="flex items-center justify-between mb-3">
                        <div className="w-10 h-10 bg-orange-50 rounded-xl flex items-center justify-center">
                            <IoNotificationsSharp size={16} className="text-orange-600" />
                        </div>

                        <div className="flex gap-2">
                            <button
                                onClick={() => navigate("/renew")}
                                className="px-3 py-1 bg-primary-light text-white rounded-lg text-xs font-medium flex items-center gap-1"
                            >
                                <FiPlus size={12} />
                                <span>Upgrade Package</span>
                            </button>
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                        <div className="text-center">
                            <div className="text-lg font-bold text-gray-900">5</div>
                            <div className="text-xs text-gray-500">Daily</div>
                            <div className="w-full bg-gray-100 rounded-full h-1 mt-1">
                                <div
                                    className="bg-orange-400 h-1 rounded-full"
                                    style={{ width: "60%" }}
                                />
                            </div>
                        </div>

                        <div className="text-center">
                            <div className="text-lg font-bold text-gray-900">150</div>
                            <div className="text-xs text-gray-500">Monthly</div>
                            <div className="w-full bg-gray-100 rounded-full h-1 mt-1">
                                <div
                                    className="bg-orange-400 h-1 rounded-full"
                                    style={{ width: "45%" }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            {/* Menu Items */}
            <section className="px-4 space-y-3">
                <div>
                    <button
                        onClick={() => setOpenPackages(true)}
                        className="w-full p-4 flex items-center justify-between bg-white rounded-2xl border border-gray-100"
                    >
                        <div className="flex items-center gap-4">
                            <div className="min-w-12 min-h-12 bg-blue-50 rounded-xl flex items-center justify-center ml-3">
                                <i className="text-primary text-lg w-4">
                                    <FaCandle />
                                </i>
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-900 text-left">Signal Packages</h3>
                                <p className="text-sm text-gray-500">Subscription Management</p>
                            </div>
                        </div>

                        <FiChevronRight size={20} className="text-gray-400" />
                    </button>
                </div>

                <div className="bg-white rounded-2xl border border-gray-100 ">
                    <div className="p-5">
                        <div className="flex items-center justify-between mb-4">
                            <div className="flex items-center gap-4">
                                <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center ml-3">
                                    <FaPercent size={18} className="text-blue-600" />
                                </div>
                                <div className="text-left">
                                    <h3 className="font-semibold text-gray-900">Commission</h3>
                                    <p className="text-sm text-gray-500">Commission Income</p>
                                </div>
                            </div>
                            <button
                                onClick={() => navigate("/commission")}
                                className="px-4 py-2 bg-blue-600 text-white rounded-xl text-sm font-medium flex items-center gap-2 hover:bg-blue-700 transition-colors"
                            >
                                <GoArrowDown size={12} />
                                <span>Withdraw</span>
                            </button>
                        </div>

                        <div
                            className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-4 border border-blue-100">
                            <div className="flex justify-between items-center">
                                <div className="text-right">
                                    <div className="text-xs text-gray-500 mb-1">
                                        Available Balance
                                    </div>
                                    {/*<div className="flex items-center text-sm text-green-600 font-bold">*/}
                                    {/*    <GoArrowUp size={12} className="ml-1"/>*/}
                                    {/*    <span>+0% This Month</span>*/}
                                    {/*</div>*/}
                                </div>
                                <div className="flex justify-center items-center gap-3">
                                    <span className="text-2xl font-bold text-gray-900">
                                        {profileInfo?.wallet?.balance?.toLocaleString() || "0"}
                                    </span>
                                    <span className="text-sm text-gray-500 mr-1">USDT</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button
                    onClick={() => navigate("/financial-report")}
                    className="w-full p-4 flex items-center justify-between bg-white rounded-2xl border border-gray-100"
                >
                    <div className="flex items-center gap-4">
                        <div
                            className="min-w-12 min-h-12 bg-green-100 bg-opacity-70 rounded-xl flex items-center justify-center ml-3">
                            <i className="text-lg w-4 text-green-600">
                                <FaReport />
                            </i>
                        </div>
                        <div className="text-left">
                            <h3 className="font-semibold text-gray-900">Financial Report</h3>
                            <p className="text-sm text-gray-500">Transaction History</p>
                        </div>
                    </div>

                    <FiChevronRight size={20} className="text-gray-400" />
                </button>

                <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
                    <div className="divide-y ">
                        <ListButton
                            leftIcon={
                                <i className="text-lg w-4 text-primary">
                                    <FaSupport />
                                </i>
                            }
                            title="Support"
                            subtitle="Tickets & Assistance"
                            onClick={() => navigate("/support")}
                            bgIconColor={"bg-primary-light bg-opacity-20"}
                        />

                        <ListButton
                            leftIcon={<GiInjustice size={18} className="text-violet-600" />}
                            title="Privacy & Policy"
                            subtitle="Policy"
                            onClick={() => navigate("/privacy-policy")}
                            bgIconColor={"bg-violet-200 bg-opacity-40"}
                        />

                        <ListButton
                            leftIcon={<FiSlash size={18} className="text-red-600" />}
                            title="Block History"
                            subtitle="Restriction Reports"
                            onClick={() => navigate("/ban-history")}
                            bgIconColor={"bg-red-200 bg-opacity-40"}
                        />

                        <ListButton
                            leftIcon={
                                <FaCircleInfo size={18} className="w-4 text-gray-700" />
                            }
                            title="About Us"
                            subtitle="Application Information"
                            onClick={() => navigate("/about")}
                            bgIconColor={"bg-gray-200 bg-opacity-40"}
                        />

                        <ListButton
                            leftIcon={
                                <BiLogOut size={24} className="mr-1 text-red-600" />
                            }
                            title="LogOut"
                            subtitle="Sign out of your account"
                            onClick={logout}
                            bgIconColor={"bg-red-200 bg-opacity-40"}
                        />
                    </div>
                </div>
            </section>

            <div className="h-20" />

            <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-3">
                <div className="flex justify-around">
                    <button className="flex flex-col items-center text-gray-400">
                        <FiHome size={20} className="mb-1" />
                        <span className="text-xs">Home</span>
                    </button>
                    <button className="flex flex-col items-center text-gray-400">
                        <FiBarChart2 size={20} className="mb-1" />
                        <span className="text-xs">Signals</span>
                    </button>
                    <button className="flex flex-col items-center text-gray-400">
                        <FiFileText size={20} className="mb-1" />
                        <span className="text-xs">News</span>
                    </button>
                    <button className="flex flex-col items-center text-primary">
                        <FiUser size={20} className="mb-1" />
                        <span className="text-xs">Profile</span>
                    </button>
                </div>
            </nav>

            {/* Popups / Bottom Sheets */}
            <PackageSheet
                openPackages={openPackages}
                setOpenPackages={setOpenPackages}
            ></PackageSheet>
            {/* <InviteSheet openInvite={openInvite} setOpenInvite={setOpenInvite} invitationCode={profileInfo?.code} invitationCodeUsers={invitationCodeUsers}></InviteSheet> */}
            {/* <WalleSheet openWallet={openWallet} setOpenWallet={setOpenWallet}></WalleSheet> */}
            <RenewSubscription
                isOpen={isRenewOpen}
                onClose={() => navigate("/profile")}
            />
        </div>
    );
};

export default Profile;
